// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelCustomRoute from "../../model/custom/Route";

export const setCustomOnClick = (result: ModelCustomRoute.Idata, parameterList: Record<string, unknown> | undefined): void => {
    result.documentConfirm.onClick = () => HelperSrc.routerHistoryPush(result.documentPreview.path, { temporaryData: parameterList });
};
